import React from "react";
import MorningTels from "./morningTels";
import Seo from "components/Seo";

const MorningCourierInquiry = () => {
    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="사용문의" />
            <MorningTels />
        </React.Fragment>
    );
};

export default MorningCourierInquiry;
